import styled from 'styled-components';

export const MetricNumbersWrapper = styled.div`
    display: flex;
    align-items: baseline;
    color: #6D6D6D;
    margin-left: 10px;
`;

export const MetricTotal = styled.div`
    font-weight: 500;
    font-size: 3.5rem;
`;

export const MetricUnit = styled.div`
    font-weight: 300;
    font-size: 2rem;
    line-height: 60px;
    padding-left: 10px;
    box-sizing: border-box;
`;

export const MetricDiff = styled.div`
    font-weight: 300;
    font-size: 2rem;
    line-height: 52px;
    color: #00A150;
    padding: 0 5px;
`;

export const MetricDiffIcon = styled.div`

`;
